import VendorsView from '@components/Vendors'
export default VendorsView
